import { instanceReports } from "../../../../services/instances";
import type {
  getReportsParams,
  getReportsReturn,
  getResultsParams,
  getResultsReturn,
  Result,
  Report,
  DeleteResultParams,
} from "../types/services";

const getResults = async ({
  columns_select,
  where_select,
}: getResultsParams): Promise<getResultsReturn> => {
  const results: Result[] = [];

  await instanceReports
    .post("/api/reportResult/all", {
      columns_select: columns_select,
      where_select: where_select,
    })
    .then((response) => {
      for (let result of response.data.result) {
        results.push({
          company_id: result.company_id,
          created_at: result.created_at,
          created_by: result.created_by,
          id: result.id,
          report_id: result.report_id,
          status: result.status,
          updated_at: result.updated_at,
          updated_by: result.updated_by,
          url: result.url,
        });
      }
    })
    .catch((error) => {
      console.error(error.message);
    });

  return {
    results: results,
  };
};

const getReports = async ({
  columns_select,
  where_select,
}: getReportsParams): Promise<getReportsReturn> => {
  let reports: Report[] = [];

  await instanceReports
    .post("/api/reports/all", {
      columns_select: columns_select,
      where_select: where_select,
    })
    .then((response) => {
      reports = response.data.result.map((report: any) => ({
        id: report.id,
        name: report.name,
        status: report.status,
        for_employees: report.for_employees,
        description: report.description,
        slug: report.slug,
        category_id: report.category_id,
      }));
    })
    .catch((error) => {
      console.error(error.message);
    });

  return { reports };
};

const deleteResult = async ({
  alert: { t, showAlert, closeAlert },
  params: { setLoading, reload, closing, body },
}: DeleteResultParams) => {
  const key = showAlert("default", t("alerts.delete_inprogress.message"));

  setLoading(true);

  await instanceReports
    .delete(`/api/reportResult/delete`, { data: body })
    .then(() => {
      closeAlert?.(key);
      showAlert("success", t("alerts.delete_success.message"));
    })
    .catch((error) => {
      console.error(error.message);
      closeAlert?.(key);
      showAlert("error", t("alerts.delete_error.message"));
    })
    .finally(() => {
      closing();
      reload();
      setLoading(false);
    });
};

export { getResults, getReports, deleteResult };
